
import { openai } from './useOpenAI.js'

export const chatOneShot = async (messages) => {
  return await openai.chat.completions.create({
    messages,
    model: 'gpt-3.5-turbo',
  })
}